export async function copyToClipboard(text: string): Promise<void> {
    if (window.isSecureContext) {
        await window.navigator.clipboard.writeText(text);
    }
}
